import {FlyerDto, FlyerPageDto} from '../../../../../dtos'
import {FlyerPage, IFlyerPageRef} from './flyerPage/FlyerPage'

import {FlyerPagesArrows} from '../../../../com/flyerPages/arrows/FlyerPagesArrows'

import './FlyerPages.scss'
import React, {useCallback, useRef, useState} from 'react'
import {useEffect} from 'react'
import styles from './FlyerPages.module.scss';
import {Box} from "@mui/material";
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";

interface IFlyerPages {
    pageIndex: number,
    data?: FlyerDto,
    onLeftArrowClick: () => void,
    onNextArrowClick: () => void,
    isDragStart: boolean;
    total: number;
}

export const FlyerPages: React.FC<IFlyerPages> = (props) => {
    const flyerPageRef = useRef<IFlyerPageRef>(null);
    const contentPagesRef = useRef<HTMLDivElement>(null);
    const {toggleActionsForFlyers} = useTypedSelector((state) => state);
    const [pageDto, setPageDto] = useState<FlyerPageDto | undefined>();

    useEffect(() => {
        // flyerPageRef.current?.reInit();
        var pageDto = props.data?.flyerPages![props.pageIndex]!
        setPageDto(pageDto)

    }, [props.data, props.pageIndex])

    let scrollCount: any = null;
    let scrollRef: any = null;
    const scroll = useCallback(
        y => {
            // setTimeout(() => {
                console.log(`scrollPageOnScreen`);
                if (y > 0) {
                    props.onNextArrowClick();
                } else {
                    props.onLeftArrowClick();
                }
            // }, 600)
        },
        [contentPagesRef]
    );

    useEffect(() => {
        const sliderElement = contentPagesRef.current;
        // Passing the same reference
        // const targetSlider = sliderRef.current as unknown as HTMLDivElement
        if (sliderElement) {
            sliderElement.addEventListener('wheel', onScrollPages)
        }
        if(toggleActionsForFlyers.isZoomIn && sliderElement){
            sliderElement.removeEventListener('wheel', onScrollPages)
        }

        return () => {
            // Passing the same reference
            const sliderElement = contentPagesRef.current;
            if (sliderElement) {
                sliderElement.removeEventListener('wheel', onScrollPages)

            }
        }
        // dispatch(setSelectedPageForTabs({
        //     pageNo: selectedPageState.pageNo - 1
        // }));
    }, [scroll, toggleActionsForFlyers.isZoomIn]);

    const onScrollPages = (e: any) => {
        clearTimeout(scrollRef);
        scrollRef = setTimeout(() => {
                scrollCount = 0;
            },
            200);
        if (scrollCount) {
            return;
        }
        scrollCount = 1;
        scroll(e.deltaY);
    }

    return (
        <Box
            ref={contentPagesRef}
            id={'flyerCanvasContainer'}
            sx={{
                flex: `1 1 auto`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                position: `relative`,
                padding: "4px",
                overflow: "auto"
                // overflow: `auto`
            }}
        >
            {
                props.total > 1 &&
                <FlyerPagesArrows
                    onLeftArrowClick={props.onLeftArrowClick}
                    onNextArrowClick={props.onNextArrowClick}
                    pageIndex={props.pageIndex}
                    totalPages={props.total}
                />
            }
            <FlyerPage ref={flyerPageRef} data={pageDto}/>
            {props.isDragStart && <div className={styles.drag_start}>

            </div>}
        </Box>
    )
}